import { setFulfilled, setPending, setRejected } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { DeleteTopicsFulfilledAction } from '../../domains/checkedTopicsFromDiscoveryTopics/deleteTopicsActions.types';
import { RemoveTopicFulfilledProps } from '../../domains/topics/removeTopicActions';
import { RemoveTopicFulfilledAction } from '../../domains/topics/removeTopicActions.types';
import { TrendingTopicsLoadAction, TrendingTopicsLoadMoreAction } from '../../domains/trendingTopicsLoad/actions.types';
import { Topic } from '../types';

import { TrendingTopics, TrendingTopicsEdge } from './types';

const loadMoreTrendingTopics = (state: TrendingTopics, trendingTopicsEdge: TrendingTopicsEdge) => {
  const currentTopicIds = state.fulfilled?.topicIds ?? [];
  const topicIds = [...currentTopicIds, ...trendingTopicsEdge.topicIds];

  return { ...state, fulfilled: { ...trendingTopicsEdge, topicIds } };
};

const removeFromTrendingTopics = (state: TrendingTopics, topicIds: Topic['id'][]) => {
  const currentTrendingTopics = state.fulfilled?.topicIds ?? [];
  const cursor = state.fulfilled?.cursor ?? null;
  const hasNextPage = state.fulfilled?.hasNextPage ?? false;
  const updatedTrendingTopicIds = currentTrendingTopics.filter((id: Topic['id']) => !topicIds.includes(id));

  if (currentTrendingTopics.length === 0) {
    return state;
  }

  return {
    ...state,
    fulfilled: {
      cursor,
      hasNextPage,
      topicIds: updatedTrendingTopicIds,
    },
  };
};

const removeTopic = (state: TrendingTopics, topicIds: RemoveTopicFulfilledProps) => {
  const curatedTopicId = topicIds?.curatedTopicId;

  return curatedTopicId ? removeFromTrendingTopics(state, [curatedTopicId]) : state;
};

const initialState: TrendingTopics = {
  pending: false,
  fulfilled: undefined,
  rejected: undefined,
};

export type TrendingTopicsAction =
  | TrendingTopicsLoadAction
  | TrendingTopicsLoadMoreAction
  | RemoveTopicFulfilledAction
  | DeleteTopicsFulfilledAction;

const reducer: Reducer<TrendingTopics, TrendingTopicsAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'TRENDING_TOPICS.LOAD_PENDING':
      return setPending();
    case 'TRENDING_TOPICS.LOAD_REJECTED':
      return setRejected(action.payload.error);
    case 'TRENDING_TOPICS.LOAD_FULFILLED':
      return setFulfilled(action.payload.entities.trendingTopicsEdge);
    case 'TRENDING_TOPICS.LOAD_MORE_FULFILLED':
      return loadMoreTrendingTopics(state, action.payload.entities.trendingTopicsEdge);
    case 'TOPIC.REMOVE_FULFILLED':
      return removeTopic(state, action.payload);
    case 'CHECKED_TOPICS_FROM_DISCOVERY_TOPICS.DELETE_TOPICS_FULFILLED':
      return removeFromTrendingTopics(state, action.payload.topicIds);
    default:
      return state;
  }
};

export default reducer;
